"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductDashboardLocation = void 0;
class ProductDashboardLocation {
}
exports.ProductDashboardLocation = ProductDashboardLocation;
//# sourceMappingURL=product-dashboard-location.response.js.map